import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

export const LazyGroupTravel = lazy(() =>
  import(/* webpackChunkName: 'GroupTravel' */ './index'),
);

export default function GroupTravel() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGroupTravel />
    </Suspense>
  );
}
